module.exports = __webpack_public_path__ + "img/35.39610234.png";